import { useCurrentUser } from "app/appHooks";
import { Navigate, Outlet } from "react-router-dom";
import { UserRole } from "utils/constants";
import { PATH_NAME } from "../pathNames";
interface Props {
  allowedRoles: UserRole[];
}
const RequireAuth = ({ allowedRoles }: Props) => {
  const { data: user } = useCurrentUser();
  const userRole = user?.role || "USER";
  return allowedRoles.includes(userRole) ? (
    <Outlet />
  ) : (
    <Navigate to={PATH_NAME.HOME_PAGE} replace />
  );
};

export default RequireAuth;
